import React, { useCallback, useEffect, useState, useRef } from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { useForm, Controller } from 'react-hook-form';
import { Row, Form, Col, Input } from 'reactstrap';
import SelectContact from 'react-select/creatable';
import { AiOutlineClear } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';
import ReactLoader from 'components/Loader';
import Select from 'react-select/async';
import { toast } from 'react-toastify';

import CustomFieldsInputsForm from '../../../shared/components/CustomFieldsInputsForm';
import CatalogProductsForm from '../../../PriceCatalog/externalForm/CatalogProductsForm';
import AddContactModal from 'views/Protocol/form/components/AddContactModal';
import OpportunityService from '../../services/opportunityService';
import RecordTypeService from '../../../../RecordType/service';
import ClientService from '../../../../Clients/service/index';
import CurrencyMask from 'components/Inputs/CurrencyMask';
import DatePicker from 'components/Inputs/DatePicker.js';
import ReactButton from 'components/Buttons/ReactButton';
import FlexSelect from 'components/Inputs/FlexSelect';
import AddAccountModal from '../AddAccountModal';
import OpportunityTemperature from '../../../../../components/OpportunityTemperature';

import { useListOpportunityStagesByRecordType } from '../../../OpportunityStages/hooks/useListOpportunityStagesByRecordType';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { formatCustomFieldsToSubmit } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { custom_select } from '../../../../../assets/styles/multiple_select';
import { AddNewContactButton } from 'components/Buttons/AddNewContactButton';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { removeFields } from 'utils/fuctions/removeObjectsFields';
import { useSearchAccounts } from '../../hooks/useSearchAccounts';
import { useSearchUsers } from 'views/User/hooks/useSearchUsers';
import { fieldsToRemove } from 'views/CRM/PriceCatalog/utils';
import { ScreenPrompt } from 'components/ScreenPrompt';
import { verifyRoles } from 'components/Authentication/VerifyRoles';

const OpportunityInputs = ({
  recordTypeId,
  isModal = false,
  callbackFunc = () => {},
  conversation = {},
  contactId = {},
  isAttendace = false
}) => {
  const history = useHistory();
  const {
    control,
    handleSubmit,
    errors,
    setValue,
    register,
    setError,
    formState,
    reset,
    watch,
    getValues
  } = useForm();
  const { isDirty } = formState;

  const isFromChat = !!isAttendace;

  const catalogFormRef = useRef(null);

  const submittedSuccessfully = useRef(false);

  const [isSubmiting, setIsSubmiting] = useState(false);
  const { isSearching, filterAccounts } = useSearchAccounts();
  const [account, setAccount] = useState();
  const [responsible, setResponsible] = useState({
    label: localStorage.getItem('name'),
    value: localStorage.getItem('login')
  });

  const [clientToSelect, setClientsToSelect] = useState([]);
  const [selectedClient, setSelectClient] = useState('');
  const [selectClientModal, setSelectClientModal] = useState('');
  const [timeoutID, setTimeoutID] = useState(null);
  const [clientNewData, setClientNewData] = useState(null);
  const [recordType, setRecordType] = useState(false);

  const { getCustomFields, customFields } = useEntityCustomFieldsByRecordType(
    entitiesName.OPPORTUNITY,
    recordTypeId
  );

  const { isSearchingUsers, searchUsers } = useSearchUsers();

  const {
    getOpportunityStagesByRecordType,
    isLoadingOpportunityStages,
    opportunityStages
  } = useListOpportunityStagesByRecordType();

  useEffect(() => {
    return () => {
      if (!submittedSuccessfully.current && isDirty && !isFromChat) {
        const currentValues = getValues();
        const cleanedData = removeFields(currentValues, fieldsToRemove);
        localStorage.setItem('opportunityValue', JSON.stringify(cleanedData));
      }
    };
  }, [isDirty, getValues, isFromChat]);

  useEffect(() => {
    if (isFromChat) return;
    const opportunity = localStorage.getItem('opportunityValue');
    if (opportunity) {
      reset(JSON.parse(opportunity));
    }
  }, [isFromChat, reset]);

  useEffect(() => {
    if (recordTypeId) {
      RecordTypeService.get(recordTypeId)
        .then((res) => {
          const recordTypeData = res.data.content.disable_link_to_product;
          setRecordType(recordTypeData);
        })
        .catch((error) => {
          const errorMsg = error.response?.data?.message;
          toast.error(errorMsg || 'Erro ao buscar tipo de registro');
        });
    }
  }, [recordTypeId]);

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    register('responsibleLogin');
  }, [register]);

  useEffect(() => {
    getOpportunityStagesByRecordType(recordTypeId);
  }, [recordTypeId, getOpportunityStagesByRecordType]);

  const handleGetClient = (value) => {
    if (value) {
      ClientService.getAllFilter('cliente', '', 'ALL', {
        nome: value,
        email: value
      })
        .then((response) => {
          const { content } = response.data;
          const sortClientsArray = sortData(content);
          const setData = sortClientsArray.map((client) => {
            const setClient = {
              email: client.email,
              telefone: client.telefone,
              label: client.nome,
              value: client.id
            };
            return setClient;
          });
          setClientsToSelect(setData);
        })
        .catch((err) => {
          const message =
            (err.response && err.response.data) || 'Erro ao carregar contatos';
          toast.error(message, {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    } else {
      setClientsToSelect();
    }
  };

  const seachClientSelect = (value) => {
    if (typeof timeoutID === 'number') {
      clearTimeout(timeoutID);
    }
    setTimeoutID(
      setTimeout(() => {
        handleGetClient(value);
      }, 1200)
    );
  };

  const setClientSelected = (client) => {
    if (client) {
      setSelectClient({ value: client.value, label: client.label });
      setClientNewData(client);
    } else {
      setSelectClient();
      setClientNewData('');
    }
  };

  const sortData = (data) => {
    const dataSort = data.sort((a, b) => {
      if (a.name) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      } else {
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) return -1;
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) return 1;
        return 0;
      }
    });
    return dataSort;
  };

  useEffect(() => {
    if (contactId && conversation?.cliente?.nome) {
      setSelectClient({ value: contactId, label: conversation?.cliente?.nome });
    }
  }, [contactId]);

  useEffect(() => {
    if (conversation?.cliente) {
      setSelectClient(
        conversation?.cliente?.id && conversation?.cliente?.nome
          ? {
              value: conversation?.cliente.id,
              label: conversation?.cliente.nome
            }
          : null
      );

      setAccount(
        conversation?.cliente?.accounts &&
          conversation?.cliente?.accounts.length > 0 &&
          conversation?.cliente?.accounts[0]?.id &&
          conversation?.cliente?.accounts[0]?.name
          ? {
              value: conversation?.cliente?.accounts[0]?.id,
              label: conversation?.cliente?.accounts[0]?.name
            }
          : null
      );
    } else {
      setSelectClient(null);
      setAccount(null);
    }
  }, [isAttendace]);

  useEffect(() => {
    if (!isFromChat) return;

    const base = {
      title: '',
      stageId: defaultStage?.id || '',
      amount: 0,
      expectedClosure: ''
    };
    reset(base);
  }, [isFromChat, defaultStage?.id, reset]);

  const onAddedAccount = useCallback((data) => {
    setAccount({
      label: data.name,
      value: data.id
    });
  }, []);

  const onSubmit = async (data) => {
    if (data.amount) {
      data.amount = data.amount
        .replace('R$', '')
        .replace(/\./g, '')
        .replace(',', '.')
        .trim();
    }
    const originalData = { ...data };
    if (!responsible || !responsible.value) {
      setError('responsibleLogin', { message: 'Campo obrigatório' });
      return;
    }

    setIsSubmiting(true);

    data.accountId = account && account.value ? Number(account.value) : null;
    data.responsibleLogin = responsible.value;

    if (selectedClient) {
      data.contactId = selectedClient?.value;
    }

    let dataToSubmit = data;

    if (!recordType && data.catalogId && catalogFormRef.current) {
      dataToSubmit = catalogFormRef.current.formatProductsAndCatalogsToShow({
        ...data
      });
    }

    const dataDTO = formatCustomFieldsToSubmit(dataToSubmit, customFields);

    try {
      const saveOpportunityPromise = await OpportunityService.createOpportunity(
        recordTypeId,
        dataDTO
      );

      toast.success('Oportunidade criada com sucesso');

      submittedSuccessfully.current = true;

      if (!isFromChat) {
        localStorage.removeItem('opportunityValue');
      }

      reset();

      setAccount(null);
      setSelectClient(null);
      setResponsible({
        label: localStorage.getItem('name'),
        value: localStorage.getItem('login')
      });

      if (!isModal && verifyRoles(['CRM_OPPORTUNITIES_EDIT'])) {
        history.push(
          `/admin/crm/opportunityEdit/${recordTypeId}/${saveOpportunityPromise?.data?.data?.id}`
        );
      } else if (!verifyRoles(['CRM_OPPORTUNITIES_EDIT'])) {
        history.push(`/admin/crm/opportunity`);
      } else {
        callbackFunc();
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          err.message ||
          'Erro ao criar a oportunidade',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );

      const cleanedData = removeFields(originalData, fieldsToRemove);
      if (!isFromChat) {
        localStorage.setItem('opportunityValue', JSON.stringify(cleanedData));
      }
    } finally {
      setIsSubmiting(false);
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const cancelAction = () => {
    if (isModal) {
      callbackFunc();
      return;
    }
    history.push('/admin/crm/opportunity', { recordTypeId });
  };

  const defaultStage = opportunityStages?.filter(
    (opportunityStage) => opportunityStage.orderNumber
  )[0];

  if (isLoadingOpportunityStages) {
    return (
      <Row className="justify-content-md-center">
        <ReactLoader />
      </Row>
    );
  }

  return (
    <>
      <ScreenPrompt
        when={isDirty && !formState.isSubmitting}
        message={`Está certo de que deseja sair? Terá que preencher os dados novamente quando retornar`}
      />
      <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
        <button
          type="button"
          style={{
            display: isModal ? 'block' : 'none',
            marginBottom: isModal ? '20px' : '0',
            border: 'none',
            background: 'none'
          }}
          onClick={() => {
            if (!isFromChat) {
              localStorage.removeItem('opportunityValue');
            }
            reset({ stageId: null });
            setValue('responsibleLogin', null);
            setResponsible(null);
          }}
          id="buttonInChild"
        >
          <span
            onClick={() => {
              document.getElementById('buttonInChild').click();
            }}
            className="small"
            style={{ cursor: 'pointer' }}
          >
            <AiOutlineClear /> Limpar campos
          </span>
        </button>

        <Row className="mb-3">
          <Col sm="12">
            <Controller
              render={(props) => (
                <OpportunityTemperature
                  initialTemperature={props.value}
                  opportunityId={null}
                  onChange={(temperature) => {
                    props.onChange(temperature);
                  }}
                />
              )}
              control={control}
              name="temperature"
              defaultValue={null}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm="6">
            <label className="form-control-label">Título*</label>
            <Controller
              render={(props) => (
                <Input
                  value={props.value}
                  onChange={props.onChange}
                  type="text"
                  placeholder="Título"
                />
              )}
              control={control}
              defaultValue=""
              rules={{ required: 'Campo obrigatório' }}
              name="title"
            />
            <ErrorMessage
              errors={errors}
              name="title"
              render={({ message }) => errorFormMessage(message)}
            />
          </Col>
          <Col>
            <label className="form-control-label">Fase da oportunidade*</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={opportunityStages || []}
                  isMulti={false}
                  value={props.value}
                  valueController={setValue}
                  fieldName="stageId"
                  labelName="name"
                  valueName="id"
                  isClearable={true}
                  disabled={isLoadingOpportunityStages}
                  closeMenuOnSelect={true}
                />
              )}
              control={control}
              defaultValue={defaultStage?.id || ''}
              rules={{
                required: 'Campo obrigatório'
              }}
              name="stageId"
            />
            <ErrorMessage
              errors={errors}
              name="stageId"
              render={({ message }) => errorFormMessage(message)}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm="6">
            <div className="d-flex">
              <div style={{ flexGrow: '10' }} className="tour3">
                <label className="form-control-label">Conta</label>
                <Select
                  styles={custom_select}
                  placeholder="Busca rápida"
                  isClearable={true}
                  name="accountId"
                  isLoading={isSearching}
                  loadingMessage={() => 'Buscando...'}
                  noOptionsMessage={({ inputValue }) =>
                    !inputValue
                      ? 'Digite para pesquisar'
                      : 'Nenhum resultado encontrado'
                  }
                  loadOptions={async (inputValue) => {
                    const res = await filterAccounts(inputValue);
                    return (
                      res &&
                      res.map((account) => ({
                        label: account.name,
                        value: account.id
                      }))
                    );
                  }}
                  onChange={(data) => {
                    if (data) {
                      const { value, label } = data;
                      setAccount({
                        label,
                        value
                      });
                    } else {
                      setAccount(null);
                    }
                  }}
                  value={
                    account
                      ? {
                          label: account.label,
                          value: account.value
                        }
                      : ''
                  }
                  defaultValue={
                    account
                      ? {
                          label: account.label,
                          value: account.value
                        }
                      : ''
                  }
                />
              </div>

              <div
                style={{
                  alignSelf: 'flex-end',
                  justifyContent: 'space-between',
                  padding: '0.6rem 0.6rem'
                }}
              >
                <AddAccountModal
                  onAddedAccount={onAddedAccount}
                  buttonOpenModal={({ onClick }) => (
                    <AddNewContactButton onClick={onClick} />
                  )}
                />
              </div>
            </div>
          </Col>

          <Col md="6">
            <div className="d-flex">
              <div style={{ flexGrow: '10' }}>
                <label className="form-control-label">Responsável*</label>
                <Select
                  styles={custom_select}
                  placeholder="Busca rápida"
                  isClearable={true}
                  name="responsibleLogin"
                  isLoading={isSearchingUsers}
                  loadingMessage={() => 'Buscando...'}
                  noOptionsMessage={({ inputValue }) =>
                    !inputValue
                      ? 'Digite para pesquisar'
                      : 'Nenhum resultado encontrado'
                  }
                  loadOptions={async (inputValue) => {
                    const data = await searchUsers(inputValue);
                    return (
                      data &&
                      data.map((user) => ({
                        label: user.name,
                        value: user.login
                      }))
                    );
                  }}
                  onChange={(data) => {
                    if (data) {
                      const { value, label } = data;
                      setResponsible({
                        label,
                        value
                      });
                    } else {
                      setResponsible(null);
                    }
                  }}
                  value={
                    responsible
                      ? {
                          label: responsible.label,
                          value: responsible.value
                        }
                      : ''
                  }
                  defaultValue={
                    responsible
                      ? {
                          label: responsible.label,
                          value: responsible.value
                        }
                      : ''
                  }
                />
                <ErrorMessage
                  errors={errors}
                  name="responsibleLogin"
                  render={({ message }) => errorFormMessage(message)}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm="6">
            <div className="d-flex">
              <div style={{ flexGrow: '10' }} className="tour3">
                <label className="form-control-label">Contato</label>
                <SelectContact
                  isClearable
                  allowCreateWhileLoading={false}
                  isValidNewOption={() => false}
                  placeholder="Busca rápida"
                  styles={custom_select}
                  value={selectedClient}
                  options={clientToSelect}
                  onInputChange={seachClientSelect}
                  onChange={setClientSelected}
                />
              </div>

              <div
                style={{
                  alignSelf: 'flex-end',
                  justifyContent: 'space-between',
                  padding: '0.6rem 0.6rem'
                }}
              >
                <AddContactModal
                  defaultFieldsAutoComplete={[
                    {
                      email: 'teste@email.com'
                    }
                  ]}
                  setSelectedContact={(result) => {
                    setSelectClientModal(result);
                  }}
                  buttonOpenModal={({ onClick }) => (
                    <AddNewContactButton onClick={onClick} />
                  )}
                />
              </div>
            </div>
          </Col>
          <Col sm="6">
            <label className="form-control-label">Valor</label>
            <Controller
              render={(props) => (
                <CurrencyMask
                  shouldDisable={!recordType}
                  valueController={setValue}
                  value={props.value}
                  fieldName="amount"
                  placeholder="Valor"
                />
              )}
              control={control}
              defaultValue={0}
              rules={{ required: 'Campo obrigatório' }}
              name="amount"
            />

            <ErrorMessage
              errors={errors}
              name="amount"
              render={({ message }) => errorFormMessage(message)}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm="6">
            <label className="form-control-label">
              Previsão de encerramento
            </label>
            <Controller
              render={(props) => (
                <div>
                  <DatePicker
                    fieldName="expectedClosure"
                    valueController={setValue}
                    defaultValue={props.value}
                  />
                </div>
              )}
              control={control}
              defaultValue=""
              name="expectedClosure"
            />
            <ErrorMessage
              errors={errors}
              name="expectedClosure"
              render={({ message }) => errorFormMessage(message)}
            />
          </Col>
          <CustomFieldsInputsForm
            fields={customFields}
            control={control}
            errors={errors}
            setValue={setValue}
            Controller={Controller}
            watch={watch}
          />
        </Row>

        {!recordType && (
          <CatalogProductsForm
            ref={catalogFormRef}
            watch={watch}
            getValues={getValues}
            control={control}
            setValue={setValue}
            proposalId={null}
          />
        )}

        <ReactButton
          btnColor="confirmation"
          type="submit"
          disabled={isSubmiting}
        >
          Salvar
        </ReactButton>

        <ReactButton
          btnColor="cancelation"
          onClick={() => {
            return cancelAction();
          }}
        >
          Cancelar
        </ReactButton>
      </Form>
    </>
  );
};

export default OpportunityInputs;
